export type FinboxToken = string;

export interface UserProgramType {
  label: string;
  value: string;
}

export type UserProgramTypes = UserProgramType[];

export interface IAuthService {
  isAuthenticated(): boolean;
  getBearerToken(): FinboxToken | null;
  setBearerToken(token: FinboxToken): void;
  removeToken(): void;
  getUserProgramTypes(): UserProgramTypes | null;
  setUserProgramTypes(userProgramTypes: UserProgramTypes): void;

  /**
   * @deprecated Replace with bearer token once backend is updated
   */
  getToken(): FinboxToken | null;
  /**
   * @deprecated Replace with bearer token once backend is updated
   */
  setToken(token: FinboxToken): void;
}

export class AuthService implements IAuthService {
  public static finboxToken: string = "finbox-dashboard-token";
  public static finboxBearerToken: string = "finbox-dashboard-bearer-token";
  public static finboxUserProgramTypes: string =
    "finbox-dashboard-user-program-types";
  public accessToken: FinboxToken | null;
  public userProgramTypes: UserProgramTypes | null;

  constructor() {
    this.accessToken = this.getToken();
    this.userProgramTypes = this.getUserProgramTypes();
  }

  getBearerToken(): string {
    return localStorage.getItem(AuthService.finboxBearerToken) || "";
  }

  setBearerToken(token: string): void {
    localStorage.setItem(AuthService.finboxBearerToken, token);
  }

  public getUserProgramTypes(): UserProgramTypes | null {
    try {
      const data = localStorage.getItem(AuthService.finboxUserProgramTypes);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      return null;
    }
  }

  public setUserProgramTypes(userProgramTypes: UserProgramTypes): void {
    try {
      this.userProgramTypes = userProgramTypes;
      localStorage.setItem(
        AuthService.finboxUserProgramTypes,
        JSON.stringify(userProgramTypes)
      );
    } catch (error) {}
  }

  public getToken() {
    let value = "";
    try {
      value = localStorage.getItem(AuthService.finboxToken) || "";
    } catch (error) {}
    return value;
  }

  public setToken(token: FinboxToken): void {
    localStorage.setItem(AuthService.finboxToken, token);
  }

  public removeToken(): void {
    localStorage.removeItem(AuthService.finboxToken);
    localStorage.removeItem(AuthService.finboxBearerToken);
    localStorage.removeItem(AuthService.finboxUserProgramTypes);
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }
}
